var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-list"},[_c('CCard',[_c('CCardHeader',[_c('strong',[_vm._v(" اطلاع از موجودی محصول ")])]),_c('CCardBody',{},[_c('CDataTableFixed',{staticClass:"mb-0 table-outline",attrs:{"hover":"","striped":"","items":_vm.items,"fields":_vm.fields,"head-color":"light","no-sorting":""},scopedSlots:_vm._u([{key:"row",fn:function(ref){
var item = ref.item;
var index = ref.index;
return [_c('td',[_c('p',[_vm._v(_vm._s(index+1))])])]}},{key:"product",fn:function(ref){
var item = ref.item;
return [_c('td',[_c('p',[_vm._v(_vm._s((item.title.title)))])])]}}])})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }